import { request } from "services/api/util";

class ServiceResourceService {
  async fetchList(endpoint, storeCode, params) {
    const config = {
      method: "get",
      url: `admin/store/${storeCode}/${endpoint}`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getListRoom(storeCode, params) {
    return this.fetchList("rooms", storeCode, params);
  }

  async getListStaff(storeCode, params) {
    return this.fetchList("staffs", storeCode, params);
  }
}

export default new ServiceResourceService();
